<div class="panel">
    <h2>{{'ACTIVITYREPORT.Title' | translate}}</h2>
    <div class="grid">
      <div class="col-2 layout"><label>{{'ACTIVITYREPORT.ProjectName' | translate}}:</label></div>
      <div class="col-6"><span>{{currentProject?.Name}}</span></div>
    </div>
    <div class="grid">
      <div class="col-3 layout"><label>{{'ACTIVITYREPORT.ProjectId' | translate}}:</label></div>
      <div class="col-6"><span>{{currentProject?.ProjectId}}</span></div>
    </div>
    <div class="grid">
      <div class="col-2 layout">
      <button class="btn btn-primary" (click)="onDeltaReportClick()">
        <span class="pi pi-home"></span>
        <span style="float:right"> </span>
        <span style="float:right"> {{'COMPONENTS.ToDeltaReport' | translate}}</span>
      </button>
    </div>
    </div>
    <div class="grid layout">
      <label class="activity-info">*{{'ACTIVITYREPORT.24Hours' | translate}}</label>
    </div>
  </div>
  <hr>
  <div class="panel">
    <app-activity-report-filters [projectId]="currentProjectId" [searchKey]='searchText' (filter)="applyFilter($event)"
      (groupActivities)="groupActivitiesBy($event)" (searchText)="searchActivities($event)"
      (collapse)="collapseAll($event)"> 
    </app-activity-report-filters>
  </div>
  <hr>
  <div class="panel">
  <div *ngIf="activities && activities.length > 0">
    <div *ngIf="!isGrouped">
      <app-activity-report-grid [activities]="activities" [pageSize]="pageSize" [searchText]="searchText"
        [(sortOrder)]="sortOrder" [(sortField)]="sortField">
      </app-activity-report-grid>
    </div>

    <div *ngIf="isGrouped" class="group-activities">
      <p-accordion [multiple]="true" [value]="0">
        <p-accordion-panel class="mt-2" *ngFor="let act of groupedActivities | async; index as i" [value]="i" [selected]="tabExpanded">
          <p-accordion-header>
            <label>{{act.header}} : {{act.activities.length}}
              {{'ACTIVITYREPORT.Activities' | translate}}</label>
          </p-accordion-header>
          <p-accordion-content>
          <app-activity-report-grid #agrid [activities]="act.activities" [searchText]="searchText" [pageSize]="pageSize"
            [(sortOrder)]="sortOrder" [(sortField)]="sortField">
          </app-activity-report-grid>
        </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
  </div>
  <div *ngIf="!activities || activities.length === 0">
    <h5>{{'ACTIVITYREPORT.NoData' | translate}}</h5>
  </div>
</div>

